// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"c17a9771","145":"59da3f22","255":"ec4a34a7","410":"05779ca8","447":"b65f1fde","510":"c701c597","519":"2bbcf9e2","535":"9609635c","554":"94c0ccce","883":"ae714907","888":"f3226d9b","917":"52cb7f66","997":"6fd7981d"}[chunkId] + ".chunk.js";
};